import { DashboardIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/work-orders',
    component: () => import('@/layouts/index.vue'),
    name: 'workOrders',
    redirect: '/work-orders/order-list',
    meta: {
      title: '工单管理',
      icon: shallowRef(DashboardIcon),
      orderNo: 0,
      permission: ['GetProductWorkOrderList'],
    },
    children: [
      {
        path: 'order-list',
        name: 'orderList',
        component: () => import('@/pages/work-order/work-order-list.vue'),
        meta: {
          title: '工单列表',
          permission: ['GetProductWorkOrderList'],
        },
      },
    ],
  },
] as RouteRecordRaw[];
